var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{directives:[{name:"utm-adder",rawName:"v-utm-adder"}],attrs:{"to":`${_vm.to}?nosto=${_vm.nostoId}`}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }